import React, { useContext, useMemo } from 'react'
import { connect } from 'react-redux'
import BackButton from '../components/BackButton'
import IdMeWidget from '../components/IdMeWidget'
import SocietyPageLayout from './SocietyPageLayout'
import Button from '../components/ui/Button'
import { isString } from 'lodash'
import ButtonLink from '../components/ui/ButtonLink'
import SocietyProgressBar from './SocietyProgressBar'
import { selectors } from 'main/ticketing/reducer'
import { GpiSubmit } from 'components/Gpi'
import { PaymentFormContext } from 'components/Gpi/GpiWrapper'

const SocietyCheckoutLayout = ({
  children,
  progress,
  title,
  introduction,
  backUrl: backUrlOverride,
  className,
  reversed,
  summary,
  idme = true,
  onContinue,
  continueDisabled,
  ticketCart,
  skipPayment = false,
  braintreeNonce,
  ...props
}) => {
  const isFirstStep = progress && progress.currentStep === 0
  const backUrl = backUrlOverride
    ? backUrlOverride
    : !isFirstStep && progress
      ? progress.steps[progress.currentStep - 1].url
      : undefined
  const gaProductID = process.env.REACT_APP_GA_PRODUCT_ID
  const isInGpiContext = Object.keys(useContext(PaymentFormContext)).length > 0

  const hasGA = useMemo(() => {
    return idme && ticketCart && ticketCart?.lineItems.some(lineItem =>
      lineItem.productId === parseInt(gaProductID)
    )
  }, [ticketCart, gaProductID])

  return (
    <SocietyPageLayout
      title={title}
      introduction={introduction}
      className={className}
      reversed={reversed}
      header={progress && <SocietyProgressBar {...progress} />}
      rightAside={
        summary && (
          <aside className="flex flex-col justify-center flex-shrink-0 p-5 space-y-5 filter drop-shadow sawtooth-bottom lg:w-1/4 lg:sticky lg:top-0">
            <header className="text-4xl text-center font-amatic">
              Order Summary
            </header>
            <hr />
            {summary}
            <hr />
            {hasGA && (
              <IdMeWidget
                text="Military service members may be eligible for discounted rates!"
                verifiedMessage="Military discount applied!"
              />
            )}
            {!skipPayment && !braintreeNonce && isInGpiContext
              ? <GpiSubmit />
              : onContinue &&
                (isString(onContinue) ? (
                  <ButtonLink
                    label="Continue"
                    primary
                    xl
                    disabled={continueDisabled}
                    to={onContinue}
                  />
                ) : (
                  <Button
                    label="Continue"
                    primary
                    xl
                    disabled={continueDisabled}
                    onClick={onContinue}
                  />
                ))}
          </aside>
        )
      }
      {...props}
    >
      {backUrl && <BackButton to={backUrl} />}
      {children}
    </SocietyPageLayout>
  )
}

function mapStateToProps(state, { ticketCart }) {
  return { 
    ticketCart: ticketCart || selectors.ticketCart(state),
    braintreeNonce: state.root.shared.braintreeNonce,
  }
}

export default connect(mapStateToProps)(SocietyCheckoutLayout)
